// Meer follows its use (golf 9): the tiles are the places opened most on this device. Pure, so it can be tested.

export interface TileUsage {
  /** Opens per place since the first one. */
  counts: Record<string, number>;
  /** The day of the first open counted ("YYYY-MM-DD"). */
  since: string | null;
  /** The order last decided, and on which day. */
  order: string[] | null;
  orderedOn: string | null;
}

export const LEARN_DAYS = 14;
export const REORDER_DAYS = 7;

function daysBetween(from: string, to: string): number {
  return Math.round((Date.parse(`${to}T00:00:00Z`) - Date.parse(`${from}T00:00:00Z`)) / 86400000);
}

/**
 * The order of the places. The default until 14 days of use; then most opened first (ties keep the default
 * order), decided again at most once a week so the tiles do not jump around (L128).
 */
export function tileOrder(defaults: string[], usage: TileUsage, today: string): { order: string[]; decided: boolean } {
  const known = (list: string[]) => [...list.filter((p) => defaults.includes(p)), ...defaults.filter((p) => !list.includes(p))];
  if (!usage.since || daysBetween(usage.since, today) < LEARN_DAYS) return { order: defaults, decided: false };
  if (usage.order && usage.orderedOn && daysBetween(usage.orderedOn, today) < REORDER_DAYS)
    return { order: known(usage.order), decided: false };
  const order = [...defaults].sort((a, b) => (usage.counts[b] ?? 0) - (usage.counts[a] ?? 0) || defaults.indexOf(a) - defaults.indexOf(b));
  return { order, decided: true };
}
